import FormQuestion from './FormQuestion';

export function doForm(questions, header, currentAnswer, depth, currentList, userNos, organicChanges, error, addToExtraScreen, leftColRefs, setLeftColRefs){

  return questions.map((aQuestion, index)=>{
    return <FormQuestion aQuestion={aQuestion} currentList={currentList} header={header} currentAnswer={currentAnswer} userNos={userNos} organicChanges={organicChanges} error={error} addToExtraScreen={addToExtraScreen} depth={depth} leftColRefs={leftColRefs} setLeftColRefs={setLeftColRefs}/>

  })

}
